export default __webpack_public_path__ + "static/media/tdee-pal-result.751bf2d9.png";